class Dropdown {
  constructor(el, options={}) {
    this._input = el;
    this._options = options
    this._options = Object.assign({}, options);
    // TODO: keyboard navigation still to migrate
    // this._input.addEventListener("keydown", this.keydown.bind(this));
    // this._input.addEventListener("keyup", this.keyup.bind(this));
  }
  
  prepareElements() {
    if (!this._drop) {
      this._drop = document.createElement('ul');
      this._drop.classList.add("dropdown");
      this._input.after(this._drop);
      this._drop.style.width = `${this._input.offsetWidth}px`
      this._drop.addEventListener('click', this.captureClick.bind(this));
      this._input.addEventListener("focus", this.showIfPopulated.bind(this));
      // this._input.addEventListener("blur", this.hide.bind(this));
    }
  }

  populate(items) {
    this.reset();
    if (items && items.length) {
      items.forEach((item) => {
        const id = item.id || item.value || item.unique_id;
        const value = item.prompt || item.name || item.title || item.value || item.id;
        const a = document.createElement('a');
        a.innerText = value;
        a.dataset.id = id;
        a.dataset.value = value;
        const li = document.createElement('li');
        li.appendChild(a);
        this._drop.appendChild(li);
      })
    }
  }

  reset() {
    if (this._drop) this._drop.innerHTML = "";
  }

  hide() {
    this._drop.classList.remove('up');
    this._input.classList.remove('up');
  }

  show(values) {
    this.prepareElements();
    if (values) this.populate(values);
    if (!this._drop.classList.contains('up')) {
      this._drop.classList.add('up');
      this._input.classList.add('up');
    }
  }

  showIfPopulated() {
    if (this._drop.innerHTML) {
      this.show();
    }
  }

  captureClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation()
      if (e.target.dataset.value) {
        this.select(e.target.dataset.value, e.target.dataset.id);
      }
    }
  }

  select(value, id) {
    this.hide();
    if (this._options.onSelect) {
      this._options.onSelect.call(this, value, id);
    }
  }

  cancel(e) {
    this.hide();
    if (this._options.onCancel) {
      this._options.onCancel.call(this);
    }
  }
}

function dropdown(el, options) {
  return new Dropdown(el, options);
}

export default dropdown;
